// ABOUTME: Clickable table header cell component for sortable columns.
// ABOUTME: Shows sort direction indicator and handles click events.

import React from 'react';
import { Box } from '@mui/material';
import { ArrowUpward, ArrowDownward } from '@mui/icons-material';

function SortableHeaderCell({
  children,
  sortKey,
  currentSortKey,
  sortDirection,
  onSort,
  isSortable = true,
  sx = {},
}) {
  const isActive = currentSortKey === sortKey;
  const canSort = isSortable;

  const handleClick = () => {
    if (canSort && onSort) {
      onSort(sortKey);
    }
  };

  return (
    <Box
      onClick={handleClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: sx.textAlign === 'center' ? 'center' : 'flex-start',
        gap: 0.5,
        cursor: canSort ? 'pointer' : 'default',
        userSelect: 'none',
        opacity: canSort ? 1 : 0.6,
        '&:hover': canSort ? {
          opacity: 0.8,
        } : {},
        ...sx,
      }}
    >
      <Box component="span">{children}</Box>
      {canSort && isActive && (
        sortDirection === 'asc' ? (
          <ArrowUpward sx={{ fontSize: '0.875rem' }} />
        ) : (
          <ArrowDownward sx={{ fontSize: '0.875rem' }} />
        )
      )}
    </Box>
  );
}

export default SortableHeaderCell;
